"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResizeController = void 0;
/**
 * 요소들의 크기 변화를 관찰하는 ReactiveController.
 *
 * 연결·렌더가 끝날 때마다 getTargets와 관찰 중인 요소를 맞추고, 연결이 끊기면 관찰자를 정리한다.
 * 그래서 호스트는 최초 연결과 재연결(DOM 이동)을 가르거나 disconnectedCallback에서 관찰자를 끊지 않는다.
 * 호스트 렌더와 무관하게 대상이 바뀌면(부모의 자식 목록 등) refresh로 직접 맞춘다.
 */
class ResizeController {
    constructor(host, options) {
        this.options = options;
        this.observed = new Set();
        this.connected = false;
        host.addController(this);
    }
    hostConnected() {
        this.connected = true;
        this.refresh();
    }
    hostUpdated() {
        this.refresh();
    }
    hostDisconnected() {
        this.connected = false;
        this.observer?.disconnect();
        this.observer = undefined;
        this.observed.clear();
    }
    /** 관찰 대상을 getTargets 기준으로 다시 맞춘다. 연결이 끊긴 동안에는 관찰을 되살리지 않는다. */
    refresh() {
        if (!this.connected)
            return;
        const observer = (this.observer ??= new ResizeObserver(() => this.options.onResize()));
        const targets = new Set(this.options.getTargets().filter((target) => target != null));
        this.observed.forEach(target => {
            if (targets.has(target))
                return;
            observer.unobserve(target);
            this.observed.delete(target);
        });
        targets.forEach(target => {
            if (this.observed.has(target))
                return;
            observer.observe(target);
            this.observed.add(target);
        });
    }
}
exports.ResizeController = ResizeController;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVzaXplLWNvbnRyb2xsZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJyZXNpemUtY29udHJvbGxlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFTQTs7Ozs7O0dBTUc7QUFDSCxNQUFhLGdCQUFnQjtJQUszQixZQUFZLElBQTRCLEVBQVUsT0FBc0I7UUFBdEIsWUFBTyxHQUFQLE9BQU8sQ0FBZTtRQUhoRSxhQUFRLEdBQUcsSUFBSSxHQUFHLEVBQVcsQ0FBQTtRQUM3QixjQUFTLEdBQUcsS0FBSyxDQUFBO1FBR3ZCLElBQUksQ0FBQyxhQUFhLENBQUMsSUFBSSxDQUFDLENBQUE7SUFDMUIsQ0FBQztJQUVELGFBQWE7UUFDWCxJQUFJLENBQUMsU0FBUyxHQUFHLElBQUksQ0FBQTtRQUNyQixJQUFJLENBQUMsT0FBTyxFQUFFLENBQUE7SUFDaEIsQ0FBQztJQUVELFdBQVc7UUFDVCxJQUFJLENBQUMsT0FBTyxFQUFFLENBQUE7SUFDaEIsQ0FBQztJQUVELGdCQUFnQjtRQUNkLElBQUksQ0FBQyxTQUFTLEdBQUcsS0FBSyxDQUFBO1FBQ3RCLElBQUksQ0FBQyxRQUFRLEVBQUUsVUFBVSxFQUFFLENBQUE7UUFDM0IsSUFBSSxDQUFDLFFBQVEsR0FBRyxTQUFTLENBQUE7UUFDekIsSUFBSSxDQUFDLFFBQVEsQ0FBQyxLQUFLLEVBQUUsQ0FBQTtJQUN2QixDQUFDO0lBRUQsK0RBQStEO0lBQy9ELE9BQU87UUFDTCxJQUFJLENBQUMsSUFBSSxDQUFDLFNBQVM7WUFBRSxPQUFNO1FBRTNCLE1BQU0sUUFBUSxHQUFHLENBQUMsSUFBSSxDQUFDLFFBQVEsS0FBSyxJQUFJLGNBQWMsQ0FBQyxHQUFHLEVBQUUsQ0FBQyxJQUFJLENBQUMsT0FBTyxDQUFDLFFBQVEsRUFBRSxDQUFDLENBQUMsQ0FBQTtRQUN0RixNQUFNLE9BQU8sR0FBRyxJQUFJLEdBQUcsQ0FDckIsSUFBSSxDQUFDLE9BQU8sQ0FBQyxVQUFVLEVBQUUsQ0FBQyxNQUFNLENBQUMsQ0FBQyxNQUFNLEVBQXFCLEVBQUUsQ0FBQyxNQUFNLElBQUksSUFBSSxDQUFDLENBQ2hGLENBQUE7UUFFRCxJQUFJLENBQUMsUUFBUSxDQUFDLE9BQU8sQ0FBQyxNQUFNLENBQUMsRUFBRTtZQUM3QixJQUFJLE9BQU8sQ0FBQyxHQUFHLENBQUMsTUFBTSxDQUFDO2dCQUFFLE9BQU07WUFFL0IsUUFBUSxDQUFDLFNBQVMsQ0FBQyxNQUFNLENBQUMsQ0FBQTtZQUMxQixJQUFJLENBQUMsUUFBUSxDQUFDLE1BQU0sQ0FBQyxNQUFNLENBQUMsQ0FBQTtRQUM5QixDQUFDLENBQUMsQ0FBQTtRQUNGLE9BQU8sQ0FBQyxPQUFPLENBQUMsTUFBTSxDQUFDLEVBQUU7WUFDdkIsSUFBSSxJQUFJLENBQUMsUUFBUSxDQUFDLEdBQUcsQ0FBQyxNQUFNLENBQUM7Z0JBQUUsT0FBTTtZQUVyQyxRQUFRLENBQUMsT0FBTyxDQUFDLE1BQU0sQ0FBQyxDQUFBO1lBQ3hCLElBQUksQ0FBQyxRQUFRLENBQUMsR0FBRyxDQUFDLE1BQU0sQ0FBQyxDQUFBO1FBQzNCLENBQUMsQ0FBQyxDQUFBO0lBQ0osQ0FBQztDQUNGO0FBL0NELDRDQStDQyJ9